import React, { useState, useEffect } from 'react';
import { Input, Button, Typography, message as antMessage, Modal } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { all_routes } from '../../../../feature-module/router/all_routes';
import api from '../../../axios/axiosInstance';

const { Text } = Typography;

const AgentPermissionOffcanvas = ({ selectedAgent, fetchAgents, show, onClose }) => {
  const navigate = useNavigate();
  const routes   = all_routes;

  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    email: '',
    isWaba: false,
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);


  useEffect(() => {
    if (selectedAgent) {
      setFormData({
        firstname: selectedAgent.firstname || '',
        lastname: selectedAgent.lastname || '',
        email: selectedAgent.email || '',
        isWaba: selectedAgent.whatsappWaba?.isConnected || false,
        transcriptionEnabled: selectedAgent.transcriptionEnabled || false,
      });
    } else {
      setFormData({ firstname: '', lastname: '', email: '', isWaba: false, transcriptionEnabled: false });
    }
    setFormErrors({});
  }, [selectedAgent]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    setFormErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  const validateForm = () => {
    const errors = {};
    let isValid = true;

    if (!formData.email) {
      errors.email = 'Email is required';
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Email is invalid';
      isValid = false;
    }

    if (!formData.firstname) {
      errors.firstname = 'First name is required';
      isValid = false;
    }

    if (!formData.lastname) {
      errors.lastname = 'Last name is required';
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      let response;
      console.log(formData,"khugjyhgdtfghjk");
      
      if (selectedAgent) {

        
        response = await api.put(`/admin/user/${selectedAgent._id}`, formData);
      } else {

        response = await api.post('/admin/user/register', formData);
      }

      if (response.data.status === 'success') {
        antMessage.success(
          selectedAgent ? 'Agent updated successfully!' : 'Agent created successfully!'
        );
        fetchAgents();
        // document.getElementById('agent_permission_offcanvas').classList.remove('show');
        onClose();
      } else {
        antMessage.error(response.data.message || 'Operation failed');
      }
    } catch (error) {
      console.error('Error:', error);
      const errData = error.response?.data;

      // Seat limit exceeded — show a dedicated modal with Buy Seats CTA
      if (errData?.agentLimitReached) {
        Modal.error({
          title: 'Agent Seat Limit Reached',
          icon: <ShoppingCartOutlined style={{ color: '#ef4444' }} />,
          content: (
            <div>
              <p style={{ marginBottom: 12 }}>
                {errData.message || `You have used all ${errData.allowedAgentCount} agent seat(s).`}
              </p>
              <p style={{ color: '#6b7280', fontSize: 13, marginBottom: 0 }}>
                Purchase additional seats from the Billing page to add more agents.
              </p>
            </div>
          ),
          okText: 'Go to Billing & Buy Seats',
          okButtonProps: { danger: true, icon: <ShoppingCartOutlined /> },
          cancelText: 'Cancel',
          okCancel: true,
          onOk: () => {
            onClose();
            navigate(routes.billing);
          },
        });
      } else {
        antMessage.error(errData?.message || 'Operation failed. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };



  return (
    <>{show && (
  <div
    className="offcanvas-backdrop fade show"
    onClick={onClose}
  />
)}
    <div
    //   className="offcanvas offcanvas-end offcanvas-large"
    //   tabIndex={-1}
    //   id="agent_permission_offcanvas"
    className={`offcanvas offcanvas-end offcanvas-large ${show ? "show" : ""}`}
  style={{
    visibility: show ? "visible" : "hidden",
    backgroundColor: "#fff",
  }}
    >
      <div className="offcanvas-header border-bottom">
        <h5 className="fw-semibold">
          {selectedAgent ? `Edit Agent: ${selectedAgent.firstname} ${selectedAgent.lastname}` : 'Add New Agent'}
        </h5>
        <button
          type="button"
          className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          <i className="ti ti-x" />
        </button>
      </div>

      <div className="offcanvas-body">
        <form>

          {/* Agent info banner */}
          {selectedAgent && (
            <div style={{ background: "#f8fafc", border: "1px solid #e5e7eb", borderRadius: 10, padding: "12px 16px", marginBottom: 16 }}>
              <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
                {(selectedAgent.PBXDetails?.PBX_EXTENSION_NUMBER || selectedAgent.extensionNumber) && (
                  <div>
                    <div style={{ fontSize: 11, color: "#9ca3af", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}>Extension</div>
                    <div style={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>
                      {selectedAgent.PBXDetails?.PBX_EXTENSION_NUMBER || selectedAgent.extensionNumber}
                    </div>
                  </div>
                )}
                {selectedAgent.assignedCallerNumbers?.length > 0 && (
                  <div>
                    <div style={{ fontSize: 11, color: "#9ca3af", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}>Assigned Numbers</div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 4 }}>
                      {selectedAgent.assignedCallerNumbers.map((num) => (
                        <span key={num} style={{ fontSize: 12, fontWeight: 500, color: "#4338ca", background: "#eef2ff", borderRadius: 6, padding: "2px 8px" }}>
                          {num}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                {!selectedAgent.PBXDetails?.PBX_EXTENSION_NUMBER && !selectedAgent.extensionNumber && !selectedAgent.assignedCallerNumbers?.length && (
                  <span style={{ fontSize: 12, color: "#9ca3af" }}>No extension or caller numbers assigned yet</span>
                )}
              </div>
            </div>
          )}


          <div className="mb-3">
            <label className="col-form-label">
              First Name <span className="text-danger">*</span>
            </label>
            <Input
              type="text"
              name="firstname"
              value={formData.firstname}
              onChange={handleInputChange}
              placeholder="Enter first name"
              status={formErrors.firstname ? 'error' : ''}
            />
            {formErrors.firstname && <Text type="danger">{formErrors.firstname}</Text>}
          </div>

          <div className="mb-3">
            <label className="col-form-label">
              Last Name <span className="text-danger">*</span>
            </label>
            <Input
              type="text"
              name="lastname"
              value={formData.lastname}
              onChange={handleInputChange}
              placeholder="Enter last name"
              status={formErrors.lastname ? 'error' : ''}
            />
            {formErrors.lastname && <Text type="danger">{formErrors.lastname}</Text>}
          </div>
<div className="mb-3">
            <label className="col-form-label">
              Email <span className="text-danger">*</span>
            </label>
            <Input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Enter email"
              status={formErrors.email ? 'error' : ''}
            />
            {formErrors.email && <Text type="danger">{formErrors.email}</Text>}
          </div>    
          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="isWaba"
              name="isWaba"
              checked={formData.isWaba}
              onChange={handleInputChange}
            />
            <label className="form-check-label" htmlFor="isWaba">
              WABA Permission
            </label>
          </div>

          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="transcriptionEnabled"
              name="transcriptionEnabled"
              checked={formData.transcriptionEnabled}
              onChange={handleInputChange}
            />
            <label className="form-check-label" htmlFor="transcriptionEnabled">
              AI Transcription Permission
              <div className="text-muted" style={{ fontSize: 12, marginTop: 2 }}>
                Allow this agent to use call transcription, AI analysis, and transcription settings.
              </div>
            </label>
          </div>


          <div className="d-flex justify-content-end mt-4">
            <Button
              type="default"
              className="me-2"
            onClick={onClose}
            >
              Cancel
            </Button>
            <Button type="primary" onClick={handleSave} loading={isSubmitting}>
              {selectedAgent ? 'Update' : 'Create'}
            </Button>
          </div>
        </form>
      </div>
    </div>
    </>
  );
};

export default AgentPermissionOffcanvas;